import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Badge } from './ui/badge';
import { Card, CardContent } from './ui/card';
import { MapPin, Briefcase, Target } from 'lucide-react';

const DomainDetailModal = ({ domain, open, onClose }) => {
  if (!domain) return null;

  const accentColor = '#d4af37';

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-h-[90vh] max-w-5xl overflow-y-auto border-none bg-white">
        <DialogHeader>
          <DialogTitle className="font-serif text-3xl font-bold" style={{ color: accentColor }}>
            {domain.name}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-8 py-4">
          {/* Overview */}
          <div>
            <h3 className="mb-3 flex items-center gap-2 text-xl font-bold text-slate-800">
              <Target className="h-6 w-6" style={{ color: accentColor }} />
              Overview
            </h3>
            <p className="leading-relaxed text-slate-700">{domain.overview}</p>
          </div>

          {/* Top Hiring Roles */}
          <div>
            <h3 className="mb-3 flex items-center gap-2 text-xl font-bold text-slate-800">
              <Briefcase className="h-6 w-6" style={{ color: accentColor }} />
              Top Hiring Roles
            </h3>
            <div className="grid gap-3 md:grid-cols-2">
              {domain.topHiringRoles.map((role, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 p-3"
                >
                  <div
                    className="h-2 w-2 flex-shrink-0 rounded-full"
                    style={{ backgroundColor: accentColor }}
                  ></div>
                  <span className="text-sm font-medium text-slate-700">{role}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Top Locations */}
          <div>
            <h3 className="mb-3 flex items-center gap-2 text-xl font-bold text-slate-800">
              <MapPin className="h-6 w-6" style={{ color: accentColor }} />
              Top Locations
            </h3>
            <div className="flex flex-wrap gap-3">
              {domain.topLocations.map((location, index) => (
                <Badge
                  key={index}
                  className="border-2 px-4 py-2 text-sm font-medium"
                  style={{
                    borderColor: accentColor,
                    backgroundColor: 'white',
                    color: accentColor
                  }}
                >
                  {location}
                </Badge>
              ))}
            </div>
          </div>

          {/* Case Studies */}
          <div>
            <h3 className="mb-4 text-xl font-bold text-slate-800">Case Studies</h3>
            <div className="space-y-4">
              {domain.caseStudies.map((study, index) => (
                <Card key={index} className="border-slate-200 shadow-md">
                  <CardContent className="p-6">
                    <h4 className="mb-2 text-lg font-bold text-slate-800">{study.title}</h4>
                    <p className="mb-3 leading-relaxed text-slate-600">{study.description}</p>
                    <div
                      className="inline-block rounded-lg px-3 py-1 text-sm font-semibold"
                      style={{ backgroundColor: `${accentColor}20`, color: accentColor }}
                    >
                      {study.impact}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DomainDetailModal;
